/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Trans } from "react-i18next";

class Footer extends Component {
  renderLink = (name, path, icon) => {
    if (!this.props.navigation?.find((n) => n.name === path)) return null;
    return (
      <li>
        <Link to={path}>{name}</Link>
      </li>
    );
  };

  renderNavigation = () => {
    if (Object.keys(this.props.generalProfile).length === 0) return null;

    // unlisten();
    return (
      <div className="row d-none d-md-flex d-lg-flex">
        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
          <div className="footerTitle">
            <Trans desc="Şirket Bilgileri">10024</Trans>
          </div>
          <ul className="footerMenu">
            {this.renderLink(
              <Trans desc="Bayi Bilgileri">10031</Trans>,
              "/dealer-info",
              "icon-icon-menu-distrubuter"
            )}
            {this.renderLink(
              <Trans desc="Organizasyon Şeması">10030</Trans>,
              "/organisation",
              "icon-icon-menu-organisation"
            )}
            {this.renderLink(
              <Trans desc="Ekibim">10028</Trans>,
              "/my-team",
              "icon-icon-menu-team"
            )}
            {this.renderLink(
              <Trans desc="Organizasyon Değişimleri">10029</Trans>,
              "/org-activities",
              "icon-icon-menu-organisation-chart"
            )}
            {this.renderLink(
              <Trans desc="Rehber">10032</Trans>,
              "/guide",
              "icon-icon-menu-general"
            )}
          </ul>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
          <div className="footerTitle">
            <Trans desc="Eğitim ve Gelişim">10025</Trans>
          </div>
          <ul className="footerMenu">
            {this.renderLink(
              <Trans desc="Eğitim Takvimi">10034</Trans>,
              "/calendar",
              "icon-icon-menu-calendar"
            )}
            {this.renderLink(
              <Trans desc="Gelişim Planı">10035</Trans>,
              "/evolution-plan",
              "icon-icon-menu-improvement"
            )}
            {this.renderLink(
              <Trans desc="Onay Bekleyen Eğitimler">10036</Trans>,
              "/pending-approval-trainings",
              "icon-icon-table-approve"
            )}
            {this.renderLink(
              <Trans desc="Yeterlilik">10037</Trans>,
              "/competency",
              "icon-icon-menu-qualification"
            )}
            {this.renderLink(
              <Trans desc="Bayi Eğitim Potansiyeli">10406</Trans>,
              "/potential-trainings",
              "icon-potansiyel-egitimler"
            )}
            {this.renderLink(
              <Trans>nav_ford-role-and-authrorize</Trans>,
              "/employee-roles",
              "icon-ford-role"
            )}
            {this.renderLink(
              <Trans desc="Eğitime Kayıtlı Çalışanlar">10527</Trans>,
              "/employee-training-registrations",
              "icon-potansiyel-egitimler"
            )}
            {this.renderLink(
              <Trans desc="Çalışan Eğitim Planı">10707</Trans>,
              "/employee-training-management",
              "icon-icon-menu-improvement"
            )}
            {this.renderLink(
              <Trans desc="Aldığım Eğitimler">10038</Trans>,
              "/completed-trainings",
              "icon-icon-menu-achived"
            )}
            {this.renderLink(
              <Trans desc="Bilgilendirme Videoları">10058</Trans>,
              "/informational-videos",
              "icon-icon-menu-achived"
            )}
            {/* {this.renderLink(
              <Trans desc="Eğitim Kataloğu">trainingcatalog</Trans>,
              "/training-catalog",
              "icon-icon-menu-achived"
            )} */}
            {this.renderLink(
              <Trans desc="Faturalar">10033</Trans>,
              "/invoices",
              "icon-icon-menu-bill"
            )}
            {this.renderLink(
              <Trans desc="Eğitim Anketi/Testi">10042</Trans>,
              "/survey",
              "icon-icon-menu-survey"
            )}
            {this.renderLink(
              <Trans desc="Aday Havuzu">10598</Trans>,
              "/applicant-pool",
              "icon-ford-role"
            )}
            {this.renderLink(
              <Trans desc="Çalışan 360">employee360_title</Trans>,
              "/employee-360",
              "icon-potansiyel-egitimler"
            )}
          </ul>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
          <div className="footerTitle">
            <Trans desc="Kurumsal">10026</Trans>
          </div>
          <ul className="footerMenu">
            {this.renderLink(
              <Trans desc="Vizyon ve Misyon">10039</Trans>,
              "/vision",
              "icon-icon-menu-vision"
            )}
            {this.renderLink(
              <Trans desc="Ford Organizasyon">10040</Trans>,
              "/ford-organization",
              "icon-icon-menu-organisation"
            )}
            {this.renderLink(
              <Trans desc="Sıkça Sorulan Sorular">10041</Trans>,
              "/faq",
              "icon-icon-menu-faq"
            )}
          </ul>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
          <div className="footerTitle">
            <Trans desc="Linkler">10027</Trans>
          </div>
          <ul className="footerMenu">
            <li>
              <a
                href="https://eu.forduniversity.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Trans desc="FU (Ford Üniversitesi)">fu</Trans>
              </a>
            </li>
            <li>
              <a
                href="https://www.starsxp.dealerconnection.com/#/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Trans desc="STARS">10043</Trans>
              </a>
            </li>
            <li>
              <a
                href="http://bilgilerim.ford.com.tr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Trans desc="Bilgilerim Ford">10044</Trans>
              </a>
            </li>
            {/* <li>
                <a
                  href="https://etis.dealerconnection.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Trans desc="Ford e-Tis">10045</Trans>
                </a>
              </li> */}
            <li>
              <a
                href="https://www.kocakademi.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Koç Akademi
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  render = () => {
    if (this.props.navigation?.length === 0) return null;
    return (
      <footer className="py-5" id="footer" style={{ zIndex: "9999" }}>
        <div className="container">
          {this.renderNavigation()}
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center my-3 bottomLogoArea">
              <img
                src="/img/ford-logo.png"
                className="img-fluid"
                alt="Ford Logo"
              />
              <img
                src="/img/ford-truck-logo.png"
                className="img-fluid ml-3"
                alt="Ford Truck Logo"
              />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 text-center copyright">
              <Trans desc="Ford Otosan. Her hakkı saklıdır">10380</Trans>
              {/* <span className="seperator">|</span> */}
              <div className="contactOpt">
                {/* <a href="tel:000" className="footer-link">
                000
              </a> */}
                <span className="seperator">|</span>
                {/* <span className="icon-icon-mail"></span> */}
                <a href="mailto:destek@fordders.com" className="footer-link">
                  destek@fordders.com
                </a>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1 design">
              <a href="https://genbil.com">
                <img
                  src="/img/genbil-logo.png"
                  className="img-fluid"
                  alt="Genbil Ford Logo - Fga - 2025"
                  title="Fga - - 2025"
                />
              </a>
            </div>
          </div>
        </div>
      </footer >
    );
  };
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
    navigation: state.profile.general.navigations,
  };
};

export default connect(mapStateToProps, null)(withRouter(Footer));
